import React from 'react';

import { TermsAndConditions } from '@project/components';

export const TermsAndConditionsMobile: React.FC = () => {
  return <TermsAndConditions />;
};
